<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Associations />
    </div>
</template>

<script>
import currentUserQuery from '@views/Associations/Browse/queryCurrentUser.graphql';

import Associations from '../Associations/Browse.vue';

export default {
  name: 'AssociationsContainer',
  components: {
    Associations,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
